import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

const componentStyles = StyleSheet.create({
  whiteRoundedLine: {
    fill: 'none',
    stroke: '#FFFFFF',
    strokeLinecap: 'round',
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
  },
});

export default class SpecialtyVehiclePowersportRefinanceSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <path
            className={css(styles.grey)}
            d="M87.593,36.5H67.686a.8.8,0,0,0-.8.8v.062a.8.8,0,0,0,.8.8h1.4l-1.873,3.621a.859.859,0,1,0,1.525.79l2.282-4.411H83.655l-2.863,6.767a.828.828,0,0,0,.44,1.084l.058.025a.827.827,0,0,0,1.084-.44l3.146-7.436h2.073a.8.8,0,0,0,.8-.8V37.3A.8.8,0,0,0,87.593,36.5Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M84.591,46.274H74.36a2.108,2.108,0,0,0-2.037,1.573l-3.4,10.971h-4.95l-4.438-7.79c1.98.132,5.4-.133,6.88-3.2a12.142,12.142,0,0,1,6.119-5.9c3.65-2.784-10.95-3.007-12.774-.223a4.887,4.887,0,0,1-4.388,2.025l-1.448-2.542a4.018,4.018,0,0,0-1.99-1.79,3.87,3.87,0,0,0-3.1.1H47.579l3.188-3.188a4.63,4.63,0,0,1,2.63-1.3,1.205,1.205,0,0,0,.722.244h7.716a.6.6,0,0,0,.6-.6V33.419a.6.6,0,0,0-.6-.6H54.119a1.21,1.21,0,0,0-.9.412,6.389,6.389,0,0,0-3.7,1.825L45.074,39.5H35.367l-5.008-5.008a6.448,6.448,0,0,0-1.434-1.078,1.216,1.216,0,0,0-1.152-.847H21.13a.6.6,0,0,0-.6.6v1.23a.6.6,0,0,0,.6.6h6.643a1.2,1.2,0,0,0,.262-.03,4.68,4.68,0,0,1,1.072.778L32.862,39.5H30.217L20.16,48.74H40.1l.963,1.038,8.466-7.852a1.436,1.436,0,0,1,2.216.35L61.953,60.187a2.106,2.106,0,0,0,1.83,1.064h5.382A2.106,2.106,0,0,0,71.2,59.68l3.4-10.973h9.989a.534.534,0,0,0,.534-.534V46.808A.534.534,0,0,0,84.591,46.274Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M81.722,52.118A9.576,9.576,0,1,0,91.3,61.694,9.576,9.576,0,0,0,81.722,52.118ZM81.7,65.8A4.393,4.393,0,1,1,86.1,61.408,4.393,4.393,0,0,1,81.7,65.8Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M24.852,52.092a9.576,9.576,0,1,0,9.576,9.576A9.576,9.576,0,0,0,24.852,52.092Zm-.02,13.682a4.393,4.393,0,1,1,4.393-4.392A4.392,4.392,0,0,1,24.832,65.774Z"
          />
          <rect className={css(styles.white)} x="20.16" y="48.711" width="21.006" height="12.413" />
          <path
            className={css(styles.actionAccent)}
            d="M38.509,51.368v7.1H22.817v-7.1H38.509m2.657-2.657H20.16V61.123H41.166V48.711Z"
          />
          <rect className={css(styles.action)} x="27.553" y="59.247" width="11.458" height="1.91" />
          <rect className={css(styles.action)} x="27.553" y="55.428" width="11.458" height="1.91" />
          <rect className={css(styles.grey)} x="27.553" y="57.337" width="11.458" height="1.91" />
          <rect className={css(styles.actionAccent)} x="39.335" y="34.106" width="2" height="6.181" />
          <rect className={css(styles.grey)} x="32.835" y="28.352" width="15.001" height="5.733" />
          <path className={css(styles.actionAccent)} d="M48.835,35.085h-17V27.352h17Zm-15-2h13V29.352h-13Z" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="44.843" y1="41.868" x2="42.988" y2="41.868" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="39.095" y1="41.868" x2="37.24" y2="41.868" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="33.347" y1="41.868" x2="31.492" y2="41.868" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="41.969" y1="44.023" x2="40.114" y2="44.023" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="36.221" y1="44.023" x2="34.366" y2="44.023" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="30.473" y1="44.023" x2="28.618" y2="44.023" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="39.095" y1="46.179" x2="37.24" y2="46.179" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="33.347" y1="46.179" x2="31.492" y2="46.179" />
          <line className={css(componentStyles.whiteRoundedLine)} x1="27.599" y1="46.179" x2="25.744" y2="46.179" />
          <path
            className={css(styles.actionAccent)}
            d="M49.433,52.5a9.576,9.576,0,1,0,9.576,9.576A9.576,9.576,0,0,0,49.433,52.5Zm-.019,13.683a4.393,4.393,0,1,1,4.393-4.393A4.393,4.393,0,0,1,49.414,66.179Z"
          />
          <path
            className={css(styles.grey)}
            d="M45.561,50.326a11.621,11.621,0,0,1,10.031,2.36c2.32,2.02,3.412,5.452,2.975,6.405,0,0-2.2-6.319-8.956-6.319a9.618,9.618,0,0,0-8.969,5.514c0,.022-.01.044-.013.066,0,0-2.427,1.208-3.108-.632C36.953,56.187,39.707,51.5,45.561,50.326Z"
          />
          <rect className={css(styles.actionAccent)} x="9.41" y="52.566" width="21.006" height="8.594" />
          <path className={css(styles.action)} d="M59.41,42.143H54.472l.9,1.581A5.05,5.05,0,0,0,59.41,42.143Z" />
          <path
            className={css(styles.action)}
            d="M66.415,47.824c-1.48,3.071-4.9,3.336-6.88,3.2l4.438,7.789h4.949l3.4-10.97a2.108,2.108,0,0,1,2.037-1.573h9.2a5.8,5.8,0,0,0-5.551-4.131H72.033A12.322,12.322,0,0,0,66.415,47.824Z"
          />
          <path
            className={css(styles.grey)}
            d="M78,49.725a11.446,11.446,0,0,1,9.883,2.325c2.286,1.99,3.374,5.5,2.944,6.436,0,0-2.184-6.352-8.836-6.352a9.476,9.476,0,0,0-8.837,5.433c0,.022-.01.043-.013.065,0,0-2.391,1.19-3.062-.623C69.522,55.5,72.234,50.881,78,49.725Z"
          />
          <rect
            className={css(styles.grey)}
            x="16.281"
            y="55.945"
            width="5.848"
            height="1.83"
            rx="0.915"
            transform="translate(38.41 113.719) rotate(180)"
          />
        </g>
      </svg>
    );
  }
}
